import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'palestra',
  titolo: 'La Palestra: provare senza toccare i dati veri',
  gruppo: 'Per iniziare',
  permesso: null,
  aCheServe: 'Con la Palestra accesa lavori su schede inventate, con i tuoi stessi ruoli. Serve per imparare, '
    + 'per provare una funzione nuova o per mostrarla a un collega senza rischi.',
  parti: [
    {
      titolo: 'Accendere e spegnere la Palestra',
      passi: [
        'In alto a destra, accanto al tuo nome e a «Esci», premi «Palestra». La pagina si ricarica.',
        'In cima alla pagina compare una fascia colorata, «Sei in palestra»: finché la vedi sei in palestra.',
        'Vedi solo la sede di formazione e le sue schede inventate. I comandi sono quelli dei tuoi incarichi: '
          + 'quello che fai di solito lo puoi provare qui.',
        'Quando hai finito, premi di nuovo «Palestra»: torni ai dati veri. Se esci dal gestionale, la '
          + 'Palestra si spegne da sola.',
      ],
      immagine: {
        file: 'palestra.webp', larghezza: 1200, altezza: 1330,
        descrizione: 'La testata con l’interruttore Palestra acceso e la fascia colorata, sopra l’elenco delle '
          + 'schede di formazione.',
      },
    },
    {
      titolo: 'Regole della Palestra',
      passi: [
        'Usa solo nomi e dati inventati, anche quando provi a creare una scheda.',
        'Prima di registrare qualcosa di vero, guarda la fascia colorata: se c’è, spegni la Palestra.',
        'In palestra posta, messenger, amministrazione e registro eventi non sono disponibili.',
        'Le schede della palestra possono essere rimesse come all’inizio da chi prepara la formazione: non '
          + 'lasciarci niente che ti serva.',
      ],
    },
  ],
  avvertenze: [
    {
      quando: 'Non trovi una scheda vera che vedevi poco fa.',
      cosaFare: 'Probabilmente la Palestra è accesa: guarda se c’è la fascia colorata e spegni l’interruttore.',
    },
  ],
  vediAnche: ['cruscotto', 'beneficiari'],
  parole: ['formazione', 'prova', 'esercitazione', 'demo', 'allenamento'],
}

export default capitolo
